import {
    Route,
    Routes,
} from 'react-router-dom';
import { ProductsPage } from "./pages/ProductsPage";
import { ProductSelectionPage } from "./pages/ProductSelectionPage";
import { SubscribePage } from "./pages/SubscribePage";
import { ProductDetailPage } from "./pages/ProductDetailPage";
import { ApplicationDetailPage } from "./pages/ApplicationDetailPage";

export const ProductsLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={<ProductsPage />}
            />
            <Route
                path='/app/:applicationId'
                element={<ApplicationDetailPage />}
            />
            <Route
                path='/select'
                element={<ProductSelectionPage />}
            />
            <Route
                path='/subscribe'
                element={<SubscribePage />}
            />
            <Route
                path='/:id'
                element={<ProductDetailPage />}
            />
        </Routes>
    );
};


